<main class="container-task-distribution form-fields-sub-module">
	@if (tasksForm) {
		<section class="task-distribution-controls ff-row-form overflow-x-hidden">
			<div class="ff-box-field ff-field-size-3">
				<lbca-select
					[label]="configuration?.controlTask?.label"
					[disabled]="tasks.length > 0 || disabled"
					[require]="true"
					[options]="taskOptions"
					(changeValue)="handleChangeValue('parent', $event)"
					[value]="tasksForm.controls['parent'].value"
					[loading]="taskOptions.length === 0"
				></lbca-select>
			</div>
			<div class="ff-box-field ff-field-size-3">
				<lbca-date-picker
					[label]="configuration?.controlDate?.label"
					[require]="true"
					[disabled]="tasks.length > 0 || disabled"
					[require]="tasksForm.controls['date']['required']"
					(changeValue)="handleChangeValue('date', $event)"
					[value]="tasksForm.controls['date'].value"
					[rules]="configuration?.controlDate?.rules || []"
					[disabledDateRules]="configuration?.controlDate?.disabledDateRules || []"
				></lbca-date-picker>
			</div>
			@if (tasks.length === 0 && !disabled) {
				<button
					[disabled]="!tasksForm.valid || loading.length > 0"
					class="btn-type-1 btn-primary mb-[20px]"
					(click)="generateTasks()"
				>
					{{ configuration?.actionCreate?.label }}
				</button>
			}
			@if (tasks.length > 0 && !disabled) {
				<button
					[disabled]="loading.length > 0"
					class="btn-type-1 btn-danger mb-[20px]"
					(click)="deleteTasks()"
				>
					{{ configuration?.actionDelete?.label }}
				</button>
			}
		</section>
	}
	@if (loading.length > 0) {
		<lbca-loading class="loadPage"></lbca-loading>
	}
	@if (taskTitles) {
		<section class="mig-component justify-center">
			@for (task of tasks; track task; let i = $index) {
				<lbca-task-list-item
					[template]="template"
					[value]="task"
					[dynamicFormService]="dynamicFormService"
					[taskOptions]="taskTitles"
					[fieldOptions]="fieldOptions"
					(changeValue)="handleTaskChange($event, task.id)"
					(error)="handleError($event, i)"
					(validateCallback)="validateCallback($event, i)"
					[disabled]="disabled"
				></lbca-task-list-item>
			}
			<div style="width: 100%">
				@if (tasks.length > 0) {
					<button class="add-button" (click)="addTask()">+</button>
				}
			</div>
		</section>
	}
</main>
